import React from 'react';
import EnsurePermission from '../../../../base/components/EnsurePermission';
import resourceSlug from '../../../../constant/resource-slug';
import { AutocompleteInput } from '../../../../base/components/ra/inputs';
import ReferenceInput from '../../../../base/components/ra/inputs/reference.input';

const RegulationInput = (props) => (
  <EnsurePermission canRead resource={resourceSlug.REGULATION}>
    <ReferenceInput
      reference={resourceSlug.REGULATION}
      source="regulation"
      label="resources.brand.fields.regulation"
      format={(data) => data?.id}
      filterToQuery={(value) => ({
        'name||$cont': value || '',
      })}
      parse={(id) => ({
        id,
      })}
      {...props}
    >
      <AutocompleteInput optionText="name" />
    </ReferenceInput>
  </EnsurePermission>
);

export default RegulationInput;
